
import { Route, Routes} from 'react-router-dom';
import Home from './pages/home/index.js';
import RedirectToExternal from './RedirectToExternal.js';
import EventosPage from './pages/events/index.js';
import EditaisPage from './pages/notices/index.js';
import OrionHubPage from './pages/orionhub/index.js';

const AppRoutes = () => {
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/alla" element={<RedirectToExternal url="https://sites.google.com/orion.ufal.br/alla/" />} />
      <Route path="/eventos" element={<EventosPage/>} />
      <Route path="/editais" element={<EditaisPage/>} />
      <Route path="/orionhub" element={<OrionHubPage />} />
      <Route path="/orionhub/*" element={<OrionHubPage />} />
    </Routes>
  );
};

export default AppRoutes;
